import './photo-block.scss';
import Swiper from 'swiper/bundle';

export default () => {
	new Swiper('.js-photo-swiper', {
		slidesPerView: 1.6,
		spaceBetween: 0,
		loop: true,
		centeredSlides: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: true
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
			}
		}
	});
};
